
import { useState, useEffect, useRef, useContext, createContext } from "react";
import { useNavigate } from "react-router-dom";


import { useUser } from "./UserContext";

import { useCoaching } from "./CoachingContext";
import { useCoachingSchedule } from "./CoachingScheduleContext";

import { TimeUnits, TimeService } from "@Beasted1010/pivotal-wisdom";


export {
  CoachingAppointmentModalContextProvider,
  useCoachingAppointmentModalContext, useCoachingAppointmentModalContextUpdate
};


const CoachingAppointmentModalContext = createContext<any>( null ); // TODO: Properly fill out
const CoachingAppointmentModalUpdateContext = createContext<any>( null );


function useCoachingAppointmentModalContext() {
  return useContext( CoachingAppointmentModalContext );
}

function useCoachingAppointmentModalContextUpdate() {
  return useContext( CoachingAppointmentModalUpdateContext );
}




enum AppointmentType { // TODO: Duplicated (e.g. CoachingScheduleContext.tsx)
  RECURRING = "Recurring",
  ADHOC = "Adhoc",
}



// TODO: Move to TYPE Interface File (.d.ts) or some Shared Library (?)
interface DaysChecked {
  monday: boolean, 
  tuesday: boolean,
  wednesday: boolean,
  thursday: boolean,
  friday: boolean,
  saturday: boolean,
  sunday: boolean,
}
interface DayTimes {
  // TODO: To support mult selections may be nice-to-have (will require Array of strings here)
  monday: string | null, 
  tuesday: string | null,
  wednesday: string | null,
  thursday: string | null,
  friday: string | null,
  saturday: string | null,
  sunday: string | null,
}



type CoachingAppointmentModalContextProps = {
  availabilityObject: any; // TODO: TYPE
  children?: JSX.Element | JSX.Element[];
}


// #########################################################################################
// TODO: RENAME availabilityObject to something more meaningful -> IT NOT JUST AVAILABLITY SINCE USING IN MyBookings as well! (i.e. also represents "appointmentObject")
// #########################################################################################
// TODO: Rename to SubjectContext ??? - But it does only have subjectData out of necessity to get programData
function CoachingAppointmentModalContextProvider( {availabilityObject, children}: CoachingAppointmentModalContextProps ) {
  // Provider handles...

  // ... Creating State

  const { selectedSubject, selectedTopic, selectedService, selectedOffer } = useCoaching();
  const { selectedAppointmentType, availabilityDataByMonth } = useCoachingSchedule();

  const { user } = useUser();


  const [ startDateTimeISO8601, setStartDateTimeISO8601 ] = useState<string>( availabilityObject.startDateTimeISO8601 );
  const [ endDateTimeISO8601, setEndDateTimeISO8601 ] = useState<string>( availabilityObject.endDateTimeISO8601 );
  const [ timezone, setTimezone ] = useState<string>( availabilityObject.timezone );

  const [ eventSupportsRecurring, setEventSupportsRecurring ] = useState<boolean>( availabilityObject.isRecurring && selectedService !== "consult" );

  const [ googleAvailabilityEventIds, setGoogleAvailabilityEventIds ] = useState<string[]>( [availabilityObject.googleAvailabilityEventId] );


  const [ formattedTime, setFormattedTime ] = useState<string>();
  const [ formattedDate, setFormattedDate ] = useState<string>();

  /*
  const startDateTimeISO8601 = availabilityObject.startDateTimeISO8601;
  const endDateTimeISO8601 = availabilityObject.endDateTimeISO8601;
  const timezone = availabilityObject.timezone;
  const googleAvailabilityEventId = availabilityObject.googleAvailabilityEventId;
  */

  const [ email, setEmail ] = useState<string>( user ? user.email : undefined );
  const [ requestDetails, setRequestDetails ] = useState( "" );

  const [ makeEventRecurring, setMakeEventRecurring ] = useState<boolean>( false );

  //const daysTillEndDateTime = // TODO: Get terminationDateTime from Server to be apart of Availability Object as well and then get DIFFERENCE between Start and End Date Time (in Days) -- USE AS DEFAULT END DATE
  //const test = TimeService.addUnitsToDateTimeISO8601( daysTillEndDateTime, TimeUnits.DAYS, startDateTimeISO8601, timezone );
  const recurrenceInitialEndDate = TimeService.addUnitsToDateTimeISO8601( 2, TimeUnits.MONTHS, startDateTimeISO8601, timezone );

  const [ recurringStartDate, setRecurringStartDate ] = useState<string>( startDateTimeISO8601.split("T")[0] ); // TODO: ERROR HANDLE (if [0] not exist...)
  const [ recurringEndDate, setRecurringEndDate ] = useState<string>( recurrenceInitialEndDate.split("T")[0] ); // TODO: ERROR HANDLE (if [0] not exist...)

  const [ recurringDaysChecked, setRecurringDaysChecked ] = useState<DaysChecked>({
    monday: false, 
    tuesday: false,
    wednesday: false,
    thursday: false,
    friday: false,
    saturday: false,
    sunday: false,
  });

  const [ recurringDayTimes, setRecurringDayTimes ] = useState<DayTimes>({
    monday: "", 
    tuesday: "",
    wednesday: "",
    thursday: "",
    friday: "",
    saturday: "",
    sunday: "",
  });



  // ... Updating State
  useEffect( () => {
    const { monthNumber, dayNumber, time24 } = TimeService.extractDateTimeISO8601Components( startDateTimeISO8601 );
    const dayOfWeek = TimeService.getDayOfWeekFromDate( startDateTimeISO8601 );
    const monthName = TimeService.getMonthNameFromNumber( monthNumber );

    const dayOfMonthWithSuffix = TimeService.getDayOfMonthOrdinalWithSuffix( String(dayNumber) );

    const time12 = convertTo12HourFormat( time24 );

    const timezoneAbbreviation = TimeService.getTimezoneAbbreviation( startDateTimeISO8601, timezone );

    setFormattedTime( `${time12} ${timezoneAbbreviation}` );
    setFormattedDate( `${dayOfWeek}, ${monthName} ${dayOfMonthWithSuffix}` );
  }, []);




  const updateEmail = ( newEmail: string ) => {
    setEmail( newEmail );
  }

  const updateRequestDetails = ( newRequestDetails: string ) => {
    setRequestDetails( newRequestDetails );
  }

  const toggleRecurringEvent = () => {
    setMakeEventRecurring( !makeEventRecurring );
  }

  const updateRecurringStartDate = ( startDate: string ) => {
    setRecurringStartDate( startDate );
  }

  const updateRecurringEndDate = ( endDate: string ) => {
    setRecurringEndDate( endDate );
  }

  const updateRecurringDaysChecked = ( day: keyof DaysChecked, dateTimeISO8601ToAvailabilityEventId: {[key: string]: string} ) => {
    // TODO: HACK - Consider if better way. Struggled to set dropdown value to default/initial due to log in updateRecurringDayTimes (causing infinite loop of calls back and forth) -- See if can find better way that doesn't repeat code (i.e. this same as updateRecurringDayTimes() code)
    if( recurringDaysChecked[day] ) { // Means checked already, so now be unchecked (thus need reset state)
      setRecurringDayTimes( (prevState: DayTimes) => ({
        ...prevState,
        [day]: "",
      }));

      const previousSelectedDateTimeISO8601 = recurringDayTimes[day] ?? "";
      console.log("(REMOVING) ... Selected DateTime...", previousSelectedDateTimeISO8601);
      const availabilityEventId = dateTimeISO8601ToAvailabilityEventId[ previousSelectedDateTimeISO8601 ];
      console.log("(REMOVING) AVAILABILITY EVENT ID = ", availabilityEventId);
      setGoogleAvailabilityEventIds( (prevState: string[]) => prevState.filter( id => id !== availabilityEventId ) );
    }
    else { // Means NOT checked already, so now being CHECKED (want default a time)
      /*
      setRecurringDayTimes( (prevState: DayTimes) => ({
        ...prevState,
        [day]: "",
      }));
      */
    }

    setRecurringDaysChecked( (prevState: DaysChecked) => ({
      ...prevState,
      [day]: !prevState[day] // Toggle for the given day
    }));
  };

  useEffect( () => {console.log("AVAIL EVENT IDS", googleAvailabilityEventIds)}, [googleAvailabilityEventIds] );

  const updateRecurringDayTimes = ( day: keyof DayTimes, selectedDateTimeISO8601: string, dateTimeISO8601ToAvailabilityEventId: {[key: string]: string} ) => {
    if( !selectedDateTimeISO8601 && recurringDaysChecked[day] ) { // Unselected a time and day IS selected -> UNSELECT IT
      updateRecurringDaysChecked( day, dateTimeISO8601ToAvailabilityEventId );
    }
    else if( selectedDateTimeISO8601 && !recurringDaysChecked[day] ) { // Selected time and day not yet selected -> SELECT IT
      updateRecurringDaysChecked( day, dateTimeISO8601ToAvailabilityEventId );

      console.log("... Selected DateTime...", selectedDateTimeISO8601);
      const availabilityEventId = dateTimeISO8601ToAvailabilityEventId[ selectedDateTimeISO8601 ];
      console.log("FOUND AVAILABILITY EVENT ID", availabilityEventId);
      if( !googleAvailabilityEventIds.includes(availabilityEventId) ) {
        setGoogleAvailabilityEventIds( (prevState: string[]) => [...prevState, availabilityEventId] );
      }
    }
    else if( selectedDateTimeISO8601 && !recurringDayTimes[day] ) { // Was defaulted (?? maybe?)
      console.log("(DEFALT? )... Selected DateTime...", selectedDateTimeISO8601);
      const availabilityEventId = dateTimeISO8601ToAvailabilityEventId[ selectedDateTimeISO8601 ];
      console.log("(DEFALT? )FOUND AVAILABILITY EVENT ID", availabilityEventId);
      if( !googleAvailabilityEventIds.includes(availabilityEventId) ) {
        setGoogleAvailabilityEventIds( (prevState: string[]) => [...prevState, availabilityEventId] );
      }
    }

    setRecurringDayTimes( (prevState: DayTimes) => ({
      ...prevState,
      [day]: selectedDateTimeISO8601,
    }));
  };

  const submitAppointment = async () => {

    //const sessionLengthInHours = 1;
    //const endDateTimeISO8601 = TimeService.addHoursToDateTimeISO8601( sessionLengthInHours, startDateTimeISO8601 as string, timezone as string );

    const dayTimesForSelections = getTimesForDaysSelected( recurringDaysChecked, recurringDayTimes );

    const appointmentData = { 
      subject: selectedSubject, 
      topic: selectedTopic,
      service: selectedService,

      requestDetails,
      price: selectedOffer ? selectedOffer.price : 100,

      //appointmentType: selectedAppointmentType,
      appointmentType: makeEventRecurring ? AppointmentType.RECURRING : AppointmentType.ADHOC,

      user: user,

      startDateTime: startDateTimeISO8601,
      endDateTime: endDateTimeISO8601,
      timezone: timezone,

      attendeeEmails: email ? [ email ] : null,

      recurringConfig: makeEventRecurring ? { // May be false since Context saves state, unchecking makeEventRecurring doesn't remove recurringDaysChecked or recurringDayTimes
        recurringStartDate: recurringStartDate,
        recurringEndDate: recurringEndDate,

        dayTimes: dayTimesForSelections,
      } : undefined,

      

      googleAvailabilityEventIds: googleAvailabilityEventIds,
    };

    const scheduleEventsEndpoint = "/api/v1/coaching/schedule/events";

    // TODO: Move to server-fetch.ts ??
    const result = await fetch( scheduleEventsEndpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify( appointmentData ),
    });

    if( !result?.ok ) { // TODO: Other/better ERROR HANDLING (?)
      console.error( "ERROR Submitting Appointment", result.status)
    }
  };




  // ... Persisting State down into Children
  return (
    <CoachingAppointmentModalContext.Provider value={ { email, requestDetails, startDateTimeISO8601, timezone, formattedTime, formattedDate, eventSupportsRecurring, makeEventRecurring, recurringStartDate, recurringEndDate, recurringDaysChecked, recurringDayTimes } } >
      <CoachingAppointmentModalUpdateContext.Provider value={ { updateEmail, updateRequestDetails, toggleRecurringEvent, updateRecurringStartDate, updateRecurringEndDate, updateRecurringDaysChecked, updateRecurringDayTimes, submitAppointment } } >
        {children}
      </CoachingAppointmentModalUpdateContext.Provider>
    </CoachingAppointmentModalContext.Provider>
  )
}


// ================================= HELPERS =================================

// TODO: MOVE TO SHARED REPO TimeService (repeated in Coaching.tsx)
function convertTo12HourFormat( time24: string ) {
  const [ hours, minutes ] = time24.split(":").map( num => parseInt(num, 10) );
  const period = hours >= 12 ? "PM" : "AM";
  const hours12 = hours % 12 || 12; // If already 12th hour, keep it, i.e. if % = 0

  const zeroBasedMinutes = minutes < 10 ? `0${minutes}` : minutes;

  return `${hours12}:${zeroBasedMinutes} ${period}`;
}

const getTimesForDaysSelected = ( recurringDaysChecked: DaysChecked, recurringDayTimes: DayTimes ) => {
  const updatedDayTimes: DayTimes = {...recurringDayTimes};
  
  Object.entries(recurringDaysChecked).forEach( ([day, isChecked]) => {
    if( !isChecked ) {
      updatedDayTimes[day as keyof DayTimes] = "";
    }
  });

  return updatedDayTimes;
};




/* */
